import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCapSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 14V4h12v10H3zm11-4V8h-3c-.8-1.5-1.7-2-3-2-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.3-.5 3-2h3z"
	})
});
export default SvgCapSquare;
